<p-panel header="Seleccione un ítem haciendo doble click">
  @if (loaded) {
    <div >
      <p-table
        [value]="lsData"
        [paginator]="true"
        [rows]="5"
        [totalRecords]="totalRows"
        styleClass="font-size: 12px; p-datatable-sm;"
        [showCurrentPageReport]="true"
        scrollDirection="both"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
        [sortField]="'Codigo'"
        [sortOrder]="1"
        >
        <ng-template pTemplate="header" let-columns>
          <tr class="header-table">
            <th scope="col" pSortableColumn="Codigo">
              <div style="text-align: center;">
                Código<p-sortIcon field="Codigo"></p-sortIcon>
              </div>
            </th>
            <th scope="col" pSortableColumn="NombreComercial">
              <div style="text-align: center;">
                Nombre Comercial<p-sortIcon field="NombreComercial"></p-sortIcon>
              </div>
            </th>
            <th scope="col" pSortableColumn="Descripcion">
              <div style="text-align: center;">
                Descripción<p-sortIcon field="Descripcion"></p-sortIcon>
              </div>
            </th>
          </tr>
          <tr>
            <th scope="col" [hidden]="true">
            </th>
            <th scope="col">
              <p-columnfilter type="text" field="Codigo"
                        matchMode="contains"
                        [showMenu]="false" (paste)="onKeyDownLettersAndNumbers($event)" (keypress)="onKeyDownLettersAndNumbers($event)"></p-columnfilter>
            </th>
            <th scope="col">
              <p-columnfilter type="text" field="NombreComercial"
                        matchMode="contains"
                        [showMenu]="false" (paste)="onKeyDownLettersAndNumbers($event)" (keypress)="onKeyDownLettersAndNumbers($event)"></p-columnfilter>
            </th>
            <th scope="col">
              <p-columnfilter type="text" field="Descripcion"
                        matchMode="contains"
                        [showMenu]="false" (paste)="onKeyDownLettersAndNumbers($event)" (keypress)="onKeyDownLettersAndNumbers($event)"></p-columnfilter>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dataTipoItem let-rowIndex="rowIndex">
          <tr style="cursor: pointer;" [pSelectableRow]="dataTipoItem" (dblclick)="onRowDblClick($event, dataTipoItem)">
            <td [hidden] = "true">
              {{dataTipoItem.Id}}
            </td>
            <td class="center">
              {{dataTipoItem.Codigo}}
            </td>
            <td class="center">
              {{dataTipoItem.NombreComercial}}
            </td>
            <td >
              {{dataTipoItem.Descripcion}}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3">No existen registros.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  } @else {
    <app-table-skeleton [columns]="3" [rows]="5"/>
  }

</p-panel>

